import { faBullhorn } from "@fortawesome/pro-regular-svg-icons"
import { Button } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { IOrder } from "order/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { Popup } from "ui/components/Popup"
import { isPhoneScreen } from "ui/tools/responsive"
import { OrderCampaignList } from "./OrderCampaignList"

interface IOrderCampaignsPopupConnectProps {
  isPhone: boolean
}

interface IOrderCampaignsPopupProps extends IOrderCampaignsPopupConnectProps {
  order: IOrder
  onClose: () => any
}

const OrderCampaignsPopupFn = React.memo(({ order, onClose, isPhone }: IOrderCampaignsPopupProps) => (
  <Popup
    icon={faBullhorn}
    id="order-form-popup"
    displayCloseIcon
    title={translate("order.campaigns.list", order.name || "-")}
    onClose={onClose}
    minWidth={"calc(100% - 2rem)"}
    maxWidth="calc(100% - 2rem)"
    sx={{
      "& h2.MuiDialogTitle-root": { minWidth: 0 },
      "& h2.MuiDialogTitle-root p": { marginRight: "1rem" }
    }}>
    <OrderCampaignList orderId={order.id} />
    <FlexBox fullWidth jc="end" sx={{ mt: "1rem" }}>
      <Button variant="outlined" size="small" onClick={onClose}>
        {translate("button.close")}
      </Button>
    </FlexBox>
  </Popup>
))

export const OrderCampaignsPopup = connect(
  (state: IRootState): IOrderCampaignsPopupConnectProps => ({
    isPhone: isPhoneScreen(state)
  })
)(OrderCampaignsPopupFn)
